@if ((useLazyLoad || isLoaded) && !isIncomplete) {
  <div class="wc-spy-target" [sdSpyTarget]="componentUid"></div>
  <wc-wrapper [contentWrapper]="wrapper">
    <wc-base-list-recipe sd-component-wrapper-component
      [recipeCards]="recipes"
      [totalCount]="recipesSize"
      [isFirst]="isFirst"
      [brandCorner]="brandCorner"
      [isLoading]="useLazyLoad && !isLoaded"
    />
  </wc-wrapper>
}
